import RouterErrorBoundary from "@/errors/RouterErrorBoundary/RouterErrorBoundary";
import React, { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";
import { Navigate, Outlet } from "react-router-dom";

const PerformanceAnalytics = lazy(() => import('../pages/PerformanceAnalytics'))
const ApplicationCharts = lazy(() => import('../pages/ApplicationCharts'))
const PositionsCharts = lazy(() => import('../pages/PositionsCharts'))
const SourcingCharts = lazy(() => import('../pages/SourcingCharts'))
const InterviewAnalytics = lazy(() => import('../pages/InterviewAnalytics'))
const RequisitionCharts = lazy(() => import('../pages/RequisitionCharts'))
const CandidatePipelineFlow = lazy(() => import('../pages/CandidatePipelineFlow'))
const CandidateCharts = lazy(() => import('../pages/CandidateCharts'))
const EvaluationReport= lazy(()=>import('../pages/EvaluationReport'))
const BlacklistedCandidateReport= lazy(() => import('../pages/BlacklistedCandidateReport'))

const ReportsLayout = () => (
  <Suspense fallback={<LoadingFeedback />}>
    <Outlet />
  </Suspense>
)

export const reportsRoutes = [
  {
    path: "/reports",
    element: <ReportsLayout />,
    errorElement: <RouterErrorBoundary />,
    children: [
      {
        index: true,
        element: <Navigate to="performance-analytics" replace />,
      },
      {
        path: "performance-analytics",
        element: <PerformanceAnalytics />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "application-charts",
        element: <ApplicationCharts />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "position-charts",
        element: <PositionsCharts />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "sourcing-charts",
        element: <SourcingCharts />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "interview-analytics",
        element: <InterviewAnalytics />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "requisition-charts",
        element: <RequisitionCharts />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "candidate-pipeline-flow",
        element: <CandidatePipelineFlow />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "evaluation-report",
        element: <EvaluationReport />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "candidate-charts",
        element: <CandidateCharts />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "blacklisted-candidate-report",
        element: <BlacklistedCandidateReport />,
        errorElement: <RouterErrorBoundary />,
      }
    ],
  },
];